export const CREATE_SYSTEM_REQUEST_COMMON = 'CREATE_SYSTEM_REQUEST_COMMON';
export const CREATE_SYSTEM_SUCCESS_COMMON = 'CREATE_SYSTEM_SUCCESS_COMMON';
export const CREATE_SYSTEM_FAILURE_COMMON = 'CREATE_SYSTEM_FAILURE_COMMON';

export const SITE_SEARCH_REQUEST_COMMON = 'SITE_SEARCH_REQUEST_COMMON';
export const SITE_SEARCH_SUCCESS_COMMON = 'SITE_SEARCH_SUCCESS_COMMON';
export const SITE_SEARCH_FAILURE_COMMON = 'SITE_SEARCH_FAILURE_COMMON';
export const GET_SITE_DETAILS = 'GET_SITE_DETAILS';
export const GET_SITE_DETAILS_SUCCESS = 'GET_SITE_DETAILS_SUCCESS';
export const GET_SITE_DETAILS_FAILURE = 'GET_SITE_DETAILS_FAILURE';

export const PROJECT_TYPES = {
  COMMERCIAL: 'COMMERCIAL',
  RESIDENTIAL: 'RESIDENTIAL',
  OTHER: 'OTHER',
};

export const SYSTEM_CREATION_TYPES = {
  EXISTING: 'EXISTING',
  NEW: 'NEW',
  NA: 'NA',
};

export const SOURCE_TYPES = [
  { type: 'Residential', value: 1 },
  { type: 'Commercial', value: 2 },
  { type: 'Other', value: 3 },
];

export const AUSTRALIA_COUNTRY_CODE = 'AU';
export const ENL_VERSION_DISABLED_COUNTRIES = [
  'US',
  'AU',
  'DE',
  'NL',
  'BE',
  'AT',
  'FR',
  'CH',
];
